import { getExperimentValue } from '@canvas/client-feature-flags';

import { getLiveDatabaseSizeMetrics } from './database-size/live-database-size-metrics';
import { type SelectionsExperimentAttributes } from './types';

/**
 * Returns common analytics attributes for the selections performance experiment.
 * Includes the cohort tag and database size (entries/fields) for segmentation.
 *
 * Usage: spread into the event data at each call site:
 * ```ts
 * analyticsClient.sendSomeEvent({
 *   ...getSelectionsExperimentAttributes(contentId),
 *   contentId,
 *   ...
 * });
 * ```
 */
export function getSelectionsExperimentAttributes(
  contentId: string
): SelectionsExperimentAttributes {
  const metrics = getLiveDatabaseSizeMetrics(contentId);

  return {
    selectionsPerformanceCohort: getExperimentValue(
      'databasesSelectionsPerformance',
      'cohort',
      { fireExperimentExposure: false }
    ),
    databaseEntryCount: metrics?.entriesCount,
    databaseFieldCount: metrics?.fieldsCount,
  };
}
